/* Common Imports */

import React from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";

/* Component Imports */

import { Typography, Tab, Tabs, Box } from "@material-ui/core";
import FoodMenu from "../food-menu/FoodMenu";
import ProductMenu from "../product-menu/ProductMenu";

const useStyles = makeStyles((theme) => ({
  sectionContainer: {
    display: "flex",
    flexDirection: "row",
    [theme.breakpoints.down("xs")]: {
      flexDirection: "column",
      justifyContent: "center",
    },
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
    margin: "5rem 0rem 1rem 0rem",
  },
  sectionSubDiv: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "center",
    width: "100%",
  },
  tabsAndTitleContainer: {
    width: "100%",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "3rem",
    [theme.breakpoints.down("md")]: {
      flexDirection: "column",
      justifyContent: "space-between",
      alignItems: "flex-start",
      marginBottom: "2rem",
    },
  },
  titleDiv: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    alignItems: "flex-start",
  },
  title: {
    fontWeight: "500",
    fontSize: "3rem",
    lineHeight: "2rem",
    letterSpacing: "0.047rem",
    marginTop: "0.5rem",
    [theme.breakpoints.down("sm")]: {
      fontSize: "1.5rem",
      lineHeight: "1.8rem",
    },
    [theme.breakpoints.down("md")]: {
      marginTop: "0rem",
      marginBottom: "1.5rem",
    },
    [theme.breakpoints.down("xs")]: {
      marginTop: "1rem",
      marginBottom: "1.5rem",
      lineHeight: "1.5rem",
    },
  },
  tabsCombined: {
    width: "30%",
    background: "#ffffff",
    color: "#343434",
    borderRadius: "4px",
    boxShadow:
      "0px 2px 4px -1px rgba(0,0,0,0.2),0px 4px 5px 0px rgba(0,0,0,0.14),0px 1px 10px 0px rgba(0,0,0,0.12)",
    "& .MuiTab-root": {
      minWidth: "auto",
      padding: "0.5rem 1rem",
    },
    "& .MuiTab-textColorInherit.Mui-selected": {
      background: "linear-gradient(180deg, #75E88A 0%, #2CB646 100%)",
      color: "#ffffff",
    },
    [theme.breakpoints.down("xs")]: {
      "& .MuiTabScrollButton-root.Mui-disabled": {
        display: "none",
      },
      width: "100%",
    },
  },
}));

/* Tab Panel MUI default Function */

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={0}>
          <Typography component="span">{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `tab-${index}`,
    "aria-controls": `tabpanel-${index}`,
  };
}

const MenuTab = () => {
  const classes = useStyles();

  /* Tab Change Handling */
  const [value, setValue] = React.useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  return (
    <React.Fragment>
      <Typography variant="h2" component="span" className={classes.title}>
        Our Menu
      </Typography>
      <div className={classes.sectionContainer}>
        <div className={classes.sectionSubDiv}>
          <div className={classes.tabsAndTitleContainer}>
            <Tabs
              variant="fullWidth"
              className={classes.tabsCombined}
              value={value}
              onChange={handleChange}
              aria-label="Our Menu"
              indicatorColor="primary"
              TabIndicatorProps={{
                style: {
                  height: 0,
                },
              }}
            >
              <Tab label="Product Menu" {...a11yProps(0)} />
              <Tab label="Food Menu" {...a11yProps(1)} />
            </Tabs>
          </div>

          {/* Tabs Content */}
          <div style={{ width: "100%" }}>
            <TabPanel value={value} index={0}>
              <ProductMenu />
            </TabPanel>
            <TabPanel value={value} index={1}>
              <FoodMenu />
            </TabPanel>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default MenuTab;
